enum OrderStateTypes {
    /** 全部 */
    ALL = 'all',
    /** 顾客已收餐 */
    COMPLETED = 'complete',
    /** 已取消 */
    CANCEL = 'cancel',
    /** 已处理退款 */
    PROCESSED_REFUND = 'processedRefund',
    /** 已处理退单 */
    PROCESSED_REMIND = 'processedRemind',
    /** 已处理定责赔付 */
    PROCESSED_DUTY = 'processedDuty',
    /** 已处理餐损赔付 */
    PROCESSED_LOSS = 'processedLoss',
    /** 待定责赔付*/
    PREP_DUTY = 'prep_duty',
    /** 非 SLA 待餐损申请 */
    NON_SLA_COMPENSATING = 'nonslaCompensating',
    /** （「大纠纷」新增）待退款申诉 */
    AFTER_SALE_CAN_APPEAL = 'afterSaleCanAppeal',
    /** 已处理食安 */
    FOOD_SAFE_ALL = 'foodSafeAll',
    /** 可申诉食安 */
    FOOD_SAFE_APPEAL_FOR_POI = 'foodSafeAppeal4Poi',
    /** 放心吃受理订单 */
    FOOD_SAFE_EAT_EASE = 'foodSafeEatEase',
}

/**
 * 待处理订单过滤类型
 *
 * 比如在待处理订单页区分各个 tab 的过滤条件
 */
enum UnprocessedOrderType {
    /** 进行中 **(不展示数量，只更新列表)** */
    Process = 'process',
    /** 自动接单 **(不展示，仅占位)** */
    Auto = 'auto',
    /** 新订单 */
    NewOrder = 'newOrder',
    /** 退单 */
    Refund = 'refund',
    /** 食安问题 - 待处理 */
    FoodSafeProcess4Poi = 'foodSafeProcess4Poi',
    /** 催单 */
    Remind = 'remind',
    /** 待出餐 */
    PrepMeal = 'prepMeal',
    /** 出餐异常 */
    Unnormal = 'unnormal',
    /** 配送异常 */
    DeliveryException = 'deliveryException',
    /** 定责赔付 (SLA 商家) */
    DutyCompensate = 'dutyCompensate',
    /** 餐损赔付 (非 SLA 商家) */
    LossCompensate = 'lossCompensate',
    /** 待发配送 */
    PrepDelivery = 'prepDelivery',
    /** 其它（待处理ETA申请） */
    Other = 'etaModify',
    /** 出餐时间考核-不准时订单-本期 */
    CurrentUnPunctualOrder = 'currentUnPunctualOrder',
    /** 出餐时间考核-不准时订单-上期 */
    LastUnPunctualOrder = 'lastUnPunctualOrder',

    // 履约新形态新增
    All = 'all',
    /** 待发配送 */
    PrepLogistics = 'prepLogistics',
    /** 出餐异常 */
    MealAbnormal = 'mealAbnormal',
    /** 配送异常 */
    LogisticsAbnormal = 'logisticsAbnormal',
    /** 已取消 */
    Cancel = 'cancel',
    /** 待接单 */
    New = 'new',
    /** 预定备餐 */
    PreOrderToMeal = 'preOrderToMeal',
    /** 收入异常 */
    IncomeAbnormal = 'incomeAbnormal',
    /** 用户退款 - 待退款申诉 */
    AfterSaleCanAppeal = 'afterSaleCanAppeal',
    /** 待餐损申诉(sla) */
    Responsible = 'responsible',
    /** 待餐损申请(非sla) */
    Cansun = 'cansun',
    /** 食安处理 - 可申诉 */
    FoodSafeAppealForPoi = 'foodSafeAppeal4Poi',
    /** 待骑手接单 */
    OrderPreRiderOrder = 'order_preRiderOrder',
    /** 待骑手到店 */
    OrderPreRiderPick = 'order_preRiderPick',
    /** 配送中 */
    OrderLogisticsing = 'order_logisticsing',
}

/** 待处理订单计数接口使用的枚举类型（注意和待处理 Tab 类型 `UnprocessedOrderType` 不一致） */
enum UnprocessedOrderCountType {
    /** 进行中 **(不展示数量，只更新列表)** */
    Process = 'process',
    /** 自动接单 **(不展示，仅占位)** */
    Auto = 'auto',
    /** 新订单 */
    NewOrder = 'newOrder',
    /** 待发配送 */
    PrepLogistics = 'prepLogistics',
    /** 配送异常 */
    LogisticsAbnormal = 'logisticsAbnormal',
    /** 待出餐 */
    PrepMeal = 'prepMeal',
    /** 出餐异常 */
    MealAbnormal = 'mealAbnormal',
    /** 退单 */
    Refund = 'refund',
    /** 食安问题 */
    FoodSafeProcess4Poi = 'foodSafeProcess4Poi',
    /** 催单 */
    Reminder = 'reminder',
    /** 餐损赔付 (非 SLA 商家) */
    Cansun = 'cansun',
    /** 定责赔付 (SLA 商家) */
    Responsible = 'responsible',
    /** 其它（ETA修改） */
    EtaModify = 'etaModify',
}

/** 订单数信息 */
interface AllCountInfo {
    /** 餐损数 */
    cansunCount: number;
    /** 新订单 */
    newOrderCount: number;
    /** 退款数 */
    refundCount: number;
    /** 催单数 */
    reminderCount: number;
    /** 待发配送数 */
    prepLogisticsCount: number;
    /** 配送异常数 */
    logisticsAbnormalCount: number;
    /** 定责数 */
    responsibleCount: number;
    /** 待出餐数 */
    prepMealCount: number;
    /** 出餐异常数 */
    mealAbnormalCount: number;
    /** 待处理食安问题数 */
    foodSafeProcess4PoiCount: number;
    /** eta修改申请订单数 */
    etaModifyCount: number;

    // 履约新形态新增
    /** 待退款申诉数量 */
    afterSaleCanAppealCount: number;
    /** 预计收入负数量 */
    incomeAbnormalCount: number;
    /** 预订单备餐数量 */
    preOrderToMealCount: number;
    /** 食安待申诉数量 */
    foodSafeAppeal4PoiCount: number;
    /** 已取消数量 */
    cancelCount: number;
    /** 配送中数量 */
    order_logisticsing_count: number;
    /** 待骑手接单数量 */
    order_preRiderOrder_count: number;
    /** 待骑手到店数量 */
    order_preRiderPick_count: number;
}

/** 隐私号状态枚举 */
enum PrivacyPhoneStatusCode {
    /** 正常 */
    NORMAL = 0,
    /** 订单未开启隐私号 */
    NOT_PRIVACY = 1,
    /** 隐私号过期 */
    EXPIRED = 2,
    /** 请求号码参数非法 */
    NUMBER_INVALID = 3,
    /** 风控限制 */
    RISK_LIMIT = 4,
    /** 隐私号功能降级*/
    DEGRADE = 5,
    /** 未查询到隐私号*/
    NO_RESULT = 6,
    /** 号码保护暂不可用于联系第三方配送人员*/
    OUTER_COURIER_LIMIT = 7,
}

/** 订单状态枚举 */
enum OrderStatusCode {
    /** 等待商家确认(新订单) */
    WAITING_CONFIRM = 2,
    /** 商家已接单 */
    CONFIRMED = 4,
    /** 订单已完成 */
    COMPLETED = 8,
    /** 订单已取消 */
    CANCELED = 9,
}

/**
 * 接单方式枚举 https://km.sankuai.com/page/37187375
 */
enum SelfServiceCode {
    GRPS = 4,
    APP = 3,
    SMS = 2,
    PC = 1,
    NOT_ACTIVE = 0,
    UNKNOWN = -1,
}

/** 配送状态枚举 */
enum LogisticsStatusCode {
    /** 待发配送 */
    INIT = -1,
    /** 正在发往配送平台（前端基本不可见此状态，代码中处理仅为了兼容） */
    SENDING = -10,
    /** 正在发往配送平台（前端基本不可见此状态，代码中处理仅为了兼容） */
    PREORDER = -20,
    /** 已发起配送 */
    WAITING = 0,
    /** 已发起配送（已推给配送） */
    WAITING_NEW = 1,
    /** 已分配骑手/待骑手接单 */
    WAITING_2 = 5,
    /** 骑手已接单 */
    ACCEPTED = 10,
    /** 骑手已到店 */
    ARRIVING = 15,
    /** 骑手已取餐 */
    DELIVERING = 20,
    /** 骑手已送达 */
    DONE = 40,
    /** 取消已配送 */
    CANCELLED = 100,
    /** 跑腿-改派骑手（中间状态，改派后会重新到待发配送状态） */
    PT_CHANGE_DELIVER = 200,
}

/** 配送类型枚举 */
enum LogisticsTypeCode {
    /** 拼好送 */
    PHS = '1005',
    /** 商家自配 */
    ZIPEI = '0000',
    /** 美团专送（加盟） */
    ZHUAN_J = '1001',
    /** 美团专送（自建） */
    ZHUAN_Z = '1002',
    /** 美团专送（城市代理） */
    ZHUAN_C = '1004',
    /** 美团跑腿-经济送 */
    ZHONGBAO = '1003',
    /** 美团跑腿-蛋糕送 */
    PAOTUI_CAKE = '2011',
    /** 美团跑腿-美团直送 */
    PAOTUI_PERSONAL = '4033',
    /** 美团快送 */
    KUAISONG = '2002',
    /** 混合送 */
    HUNHE = '3001',
    /** 混合送（加盟） */
    HUNHE_J = '30011001',
    /** 混合送（自建） */
    HUNHE_Z = '30011002',
    /** 混合快送 */
    HUNHE_K = '30012002',
    /** 全城送 FIXME: PM和客户端的文档里时 2010，需要确认 */
    QUANCHENG = '1040',
    /** 聚合送 */
    JUHE = '5001',
    /** 三方配送 */
    SANFANG = '999',
    /** 企客-光速达 */
    QIKE_GUANG = '4001',
    /** 企客-快速达 */
    QIKE_KUAI = '4011',
    /** 企客-及时达*/
    QIKE_JI = '4012',
    /** 企客-全城送 */
    QIKE_CITY = '4015',
    /** 企客-光速达-加盟运力 */
    QIKE_GUANG_JIA = '40011001',
    /** 企客-光速达-众包运力 */
    QIKE_GUANG_ZHONG = '40012002',
    /** 企客-快速达-加盟运力 */
    QIKE_KUAI_JIA = '40111001',
    /** 企客-快速达-众包运力 */
    QIKE_KUAI_ZHONG = '40112002',
    /** 企客-及时达-加盟运力 */
    QIKE_JI_JIA = '40121001',
    /** 企客-及时达-众包运力 */
    QIKE_JI_ZHONG = '40122002',
    /** 海葵自配 */
    HAIKUI_ZIPEI = '00009002',
    /** 开放平台自配 */
    OPEN_PLATFORM_ZIPEI = '00009003',
}

/** 支付状态枚举 */
enum PayStatusCode {
    /** 非在线支付 */
    OFFLINE_PAID = 0,
    /** 待付款 */
    NOT_PAIED = 1,
    /** 付款中 */
    PAYING = 2,
    /** 支付成功 */
    PAY_SUCCESS = 3,
    /** 支付失败 */
    PAY_FAIL = 4,
    /** 申请退款 */
    REFUND_APPLY = 5,
    /** 同意退款 */
    REFUND_CONFIRM = 6,
    /** 拒绝退款 */
    REFUND_REFUSED = 7,
    /** 退款成功 */
    REFUND_SUCCESS = 8,
}

/** 取餐方式枚举 */
enum PickTypeCode {
    /** 普通订单，配送到消费者手中 */
    NORMAL_DELIVERY = 0,
    /** 到店自取 */
    SELF_PICK = 1,
}

/** 备餐状态枚举值 */
enum OrderPrepareStatusCode {
    /** 不展示备餐区（自配，企客等类型） */
    NONE = 0,
    /** 备餐中 */
    PREPARING = 1,
    /** 出餐完成 */
    DONE = 2,
    /** 已取消 */
    CANCELLED = 3,
}

/** 支付方式枚举 */
enum PayTypeCode {
    /** 货到付款 */
    ON_RECEIVE = 1,
    /** 在线支付 */
    ONLINE = 2,
}

/** 订单业务类型 */
enum OrderBusinessType {
    /** 普通外卖订单 */
    WM = 1,
    /** 拼好饭订单 */
    PHF = 2,
}

/** 配送异常枚举 */
enum DispatchExceptionCode {
    /** 发配送超时15分钟没有骑手抢单 */
    DISPATCH_OUT_TIME15 = 1,
    /** 骑手抢单超时未到店 */
    TO_STORE_OUT_TIME = 2,
    /** 骑手到店超时未取餐 */
    GET_MEAL_OUT_TIME = 3,
    /** 预订单预计送达时间X分钟前未取餐，合并为一个 */
    PRE_ORDER_COMBINE = 4,
    /** 发配送超时30分钟没有骑手抢单 */
    DISPATCH_OUT_TIME30 = 5,
    /** 骑手上报联系不上用户 */
    LOSS_RELATION_USER = 6,
    /** 订单金额过大 */
    ORDER_SUM_LARGE = 7,
    /** 取餐员尚未取餐 - 无人机 */
    DISPATCH_ERROR_UAV = 8,
    /** 骑手转单 */
    DISPATCHER_TRANSFER = 9,
    /** 骑手取消 */
    DISPATCHER_CANCEL = 10,
    /** 骑手取餐前多次取消运单，触发干预系统暂停配送 */
    DISPATCHER_CANCEL_BEFORE_MEAL_TAKEN_REPEATEDLY = 12,
    /** 骑手取餐后多次取消运单，触发干预系统终止配送 */
    DISPATCHER_CANCEL_AFTER_MEAL_TAKEN_REPEATEDLY = 13,
    /** 骑手取餐前取消运单 */
    DISPATCHER_CANCEL_BEFORE_MEAL_TAKEN = 24,
    /** 骑手取餐后取消运单 */
    DISPATCHER_CANCEL_AFTER_MEAL_TAKEN = 25,
    /** 超大订单配送取消 */
    SUPER_BIG_ORDER_DELIVERY_CANCEL = 11,
    /** 发配送超时60分钟没有骑手抢单 */
    DISPATCH_OUT_TIME60 = 14,
    /** 无骑手接单兜底场景，具体触发条件可参见[无骑手接单一期遗留问题优化](https://km.sankuai.com/collabpage/1599325354) */
    DISPATCH_OUT_FALLBACK = 17,
    /** 商家核实无餐异常，商品卖空 */
    DISPATCH_SELL_OUT = 27,
    /** 商家核实无餐异常，自取 */
    DISPATCH_SELF_PICK = 28,
    /** 商家核实无餐异常，自行配送 */
    DISPATCH_ZI_PEI = 29,
}

/** 订单通用信息 */
type OrderCommonInfo = {
    /** 订单当日流水号 */
    dayNo: number;
    /** 订单viewId */
    wmOrderViewIdStr: string;
    /** 下单时间戳（单位：秒） TODO: 接口出来后看一下 */
    orderCtime: number;
    /**
     * 预计送达时间戳（单位：秒） TODO: 接口出来后看一下
     * - 预订单：即为期望送达时间
     * - 非预订单：C端估计的送达时间
     */
    estimateArrivalTime: number;
    /** 订单所属tab索引列表，APP专用，PC直接忽略 */
    tabIndexes: number[];
};

/**
 * 所有订单查询接口返回的聚合了各种业务订单的原始订单信息
 *
 * 为了保证不同业务的扩展性，commonInfo 和 orderInfo 字段均为 JSON 字符串
 *
 */
type RawOrderBaseInfo = {
    /** 业务类型 */
    businessType: OrderBusinessType;
    /**
     * 订单通用信息，不同业务类型订单该字段内的JSON结构是**一样的**，字段参考{@link OrderCommonInfo}
     * ```json
    {
        "dayNo": 1,
        "wmOrderViewIdStr": "82345611923934",
        "orderCtime": 1627091652,
        "estimateArrivalTime": 1627091652,
        "tabIndexes": [ 1, 2, 3 ]
    }
     * ```
     * */
    commonInfo: string;
    /** 订单信息，不同业务类型订单该字段内的JSON结构可能不一样 */
    orderInfo: string;
    /** 接口下发时，服务端时间 */
    serverTime?: number;
};

/** 外卖 & PHF 通用的订单基础信息 */
type OrderUnifiedInfo = {
    wmPoiId: number;
    wmOrderViewId: string;
    businessType: OrderBusinessType;
    orderType?: number;
};
type KcPageConfig = {
    hasShowKcToast: boolean;
    kcToastMsg: string;
    hasShowKcUpgradeWindow: false;
    kcUpgradeWindowToastMsg: {
        content: string;
        subContent: string;
    };
};

export {
    OrderStateTypes,
    UnprocessedOrderType,
    UnprocessedOrderCountType,
    PrivacyPhoneStatusCode,
    OrderStatusCode,
    LogisticsStatusCode,
    PayStatusCode,
    LogisticsTypeCode,
    PickTypeCode,
    OrderPrepareStatusCode,
    SelfServiceCode,
    PayTypeCode,
    OrderBusinessType,
    OrderCommonInfo,
    RawOrderBaseInfo,
    DispatchExceptionCode,
    AllCountInfo,
    OrderUnifiedInfo,
    KcPageConfig,
};
